import React from 'react'

import {DynamicModuleLoader} from 'redux-dynamic-modules'

import {getAppModule} from './model/module'

import App from './component'

export default function DynamicHome(props) {
	return (
		<DynamicModuleLoader modules={[getAppModule()]}>
			<App {...props}/>
		</DynamicModuleLoader>
	)
}
